import { HttpClient, HttpHeaders ,HttpParams} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment"
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class AirManagementService {

  constructor(private http : HttpClient) {}

  saveGroup(result:any) {
   
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/common/addGroup",result,{headers : headers,observe:"response"});
   }
   saveBusinessGroup(result:any) {
   
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/common/businessGroup/save",result,{headers : headers,observe:"response"});
   }


   
   saveQueue(result:any) {
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/common/queue/save",result,{observe:"response"});
   }
   
   deleteQueue(result: any) {
    let headers = new HttpHeaders();
    return this.http.delete(environment.API_URL + "/api/common/deleteQueue/"+result, {
        observe: "response"
    });
}

   getQueueList(request:{page:any,size:any},search:{searchText:any,userType:any}) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
        httpParam=httpParam.append("page", request.page);
        httpParam=httpParam.append("size", request.size);
        httpParam=httpParam.append("searchText", search.searchText);

      return this.http.get( environment.API_URL+"/api/common/queue" ,{ observe : "body", params : httpParam,responseType : "json"})
   
  }
  QueueAlllist() {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.get( environment.API_URL+"/api/common/getAllQueue" ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }

   getGroupList(request:{page:any,size:any},search:{searchText:any,userType:any}) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
        httpParam=httpParam.append("page", request.page);
        httpParam=httpParam.append("size", request.size);
        httpParam=httpParam.append("searchText", search.searchText);

      return this.http.get( environment.API_URL+"/api/common/getGroups" ,{headers : header, observe : "body", params : httpParam,responseType : "json"})
   
  }

  

  getPolicyList(request:{page:any,size:any},search:{searchText:any,userType:any}) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
        httpParam=httpParam.append("page", request.page);
        httpParam=httpParam.append("size", request.size);

      return this.http.get( environment.API_URL+"/api/approval/workflow/list" ,{ observe : "body", params : httpParam,responseType : "json"})
   
  }

  getBusinessGroupList(request:{page:any,size:any},search:{searchText:any,userType:any}) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
        httpParam=httpParam.append("page", request.page);
        httpParam=httpParam.append("size", request.size);
        httpParam=httpParam.append("searchText", search.searchText);

      return this.http.get( environment.API_URL+"/api/common/getBusinessGroups" ,{headers : header, observe : "body", params : httpParam,responseType : "json"})
   
  }

  grouplist() {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.get( environment.API_URL+"/api/common/getAllGroups" ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
  businessGrouplist() {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.get( environment.API_URL+"/api/common/getAllBusinessGroups" ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
  tenantlist() {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.get( environment.API_URL+"/api/tenants" ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }



  saveSupplier(result:any) {
   
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/common/addSupplier",result,{headers : headers,observe:"response"});
   }
   
   UploadGstbycarrierDesignatorCode(carrierDesignatorCode:any,request:any){
      
    let headers = new HttpHeaders();
    const formData = new FormData();
    formData.append("file", request)
    return this.http.post(environment.API_URL+"/api/common/carrier/bulk/"+carrierDesignatorCode,formData,{headers : headers,observe:"response"});
 
    }
    
    UploadMiles(request:any){
      
      let headers = new HttpHeaders();
      const formData = new FormData();
      formData.append("file", request)
      return this.http.post(environment.API_URL+"/api/common/miles/bulk",formData,{headers : headers,observe:"response"});
   
      }

   getSupplierList(request:{page:any,size:any},search:{searchText:any,userType:any}) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
        httpParam=httpParam.append("page", request.page);
        httpParam=httpParam.append("size", request.size);
        httpParam=httpParam.append("searchText", search.searchText);

      return this.http.get( environment.API_URL+"/api/common/getSuppliers" ,{headers : header, observe : "body", params : httpParam,responseType : "json"})
   
  }

  supplierlist() {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.get( environment.API_URL+"/api/common/getSuppliersList" ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }



  saveSource(result:any) {
   
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/common/addSource",result,{headers : headers,observe:"response"});
   }
   saveFareCarrier(result:any) {
   
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/common/carrierFares",result,{headers : headers,observe:"response"});
   }
   saveTaxCarrier(result:any){

    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/common/carrierTaxes",result,{headers : headers,observe:"response"});
   }
   getCarrierFareList(param:any) {
    let headers = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();

    return this.http.post(environment.API_URL+"/api/common/carrierFaresList/"+param,{observe : "body", params : httpParam,responseType : "json"});
   }

   getCarrierForeignList(param:any) {
    let headers = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();

    return this.http.post(environment.API_URL+"/api/common/carrierTaxesList/"+param,{observe : "body", params : httpParam,responseType : "json"});
   }
   getSourceList(request:{page:any,size:any},search:{searchText:any,userType:any}) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
        httpParam=httpParam.append("page", request.page);
        httpParam=httpParam.append("size", request.size);
        httpParam=httpParam.append("searchText", search.searchText);

      return this.http.get( environment.API_URL+"/api/common/getSources" ,{headers : header, observe : "body", params : httpParam,responseType : "json"})
  
  }
  sourcelist() {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.get( environment.API_URL+"/api/common/getSourcesList" ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }

  sourcelistbyUUId(userUId:any) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/common/getListSource?userUid="+userUId ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
  saveCarrier(result:any) {
   
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/common/addCarrier",result,{headers : headers,observe:"response"});
   }
   UpdateCarrier(result:any) {
   
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/common/carrier/"+result?.airlineDesignatorCode,result,{headers : headers,observe:"response"});
   }
   saveGstbyCarrier(result:any) {
   
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/common/carrier/gst",result,{headers : headers,observe:"response"});
   }

    getGstbyCarrier(carrierCode:any){
      
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/common/carrier/gst/"+carrierCode,{headers : headers,observe:"response"});
 
    }
   getCarrierList(request:{page:any,size:any},search:{searchText:any,userType:any}) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
        httpParam=httpParam.append("page", request.page);
        httpParam=httpParam.append("size", request.size);
        httpParam=httpParam.append("searchText", search.searchText);

      return this.http.get( environment.API_URL+"/api/common/getCarriers" ,{headers : header, observe : "body", params : httpParam,responseType : "json"})
   
  }
  carrierlist() {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.get( environment.API_URL+"/api/common/getCarrierList" ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
  iataCommissionlist(carrierCode:any) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/common/commission/"+carrierCode ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }


  sourceCodelist() {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/product/air/tags/sources" ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }

  clauseslist() {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.get( environment.API_URL+"/api/policy/air/rpolicies" ,{headers : header, observe : "body",responseType : "json"})  
  }
  AttributeList(item:any) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
    if(item==='Trip'){
      return this.http.get( environment.API_URL+"/api/crm/trip-attributes" ,{ observe : "body",responseType : "json"})  

    }else{
      return this.http.get( environment.API_URL+"/api/crm/employee-attributes" ,{ observe : "body", responseType : "json"})  

    }
  }

  savePolicy(result:any) {
   
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/approval/workflow/save",result,{headers : headers,observe:"response"});
   }
   updatePolicy(result:any,id:any){
    let headers = new HttpHeaders();
    return this.http.put(environment.API_URL+"/api/approval/workflow/update/"+id,result,{headers : headers,observe:"response"});
   }



  getMeal(request:any){
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/product/air/meals",request,{headers : headers,observe:"response"});

  }
  saveMeal(request:any){
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/product/air/meal",request,{headers : headers,observe:"response"});

  }
  deleteMeal(request:any){
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/product/air/deletemeal",request,{headers : headers,observe:"response"});

   
  }
  saveMiles(request:any){
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/common/mile",request,{headers : headers,observe:"response"});

  }
  saveAirports(request:any){
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/common/airport",request,{headers : headers,observe:"response"});

  }


  getMilesList(request:{number:any,size:any},searchText:any) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
        httpParam=httpParam.append("page", request.number);
        httpParam=httpParam.append("size", request.size);
        httpParam=httpParam.append("searchText", searchText);

      return this.http.get( environment.API_URL+"/api/common/allmiles" ,{headers : header, observe : "body", params : httpParam,responseType : "json"})
   
  }
  getMealList(request:{number:any,size:any},searchText:any) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
        httpParam=httpParam.append("page", request.number);
        httpParam=httpParam.append("size", request.size);
        httpParam=httpParam.append("searchText", searchText);

      return this.http.get( environment.API_URL+"/api/product/air/meals/paginated/list" ,{headers : header, observe : "body", params : httpParam,responseType : "json"})
   
  }

  getAirportsList(request:{number:any,size:any},searchText:any) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
        httpParam=httpParam.append("page", request.number);
        httpParam=httpParam.append("size", request.size);
        httpParam=httpParam.append("searchText", searchText);

      return this.http.get( environment.API_URL+"/api/common/airports" ,{headers : header, observe : "body", params : httpParam,responseType : "json"})
   
  }

 
  branchlist() {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/common/branchlist" ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
  saveBranch(request:any){
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/common/branch",request,{headers : headers,observe:"response"});
  }
}

